
import './output.css';
import {defaultSchema} from './data'
import { generateMeshCSS } from './functions';
import { useEffect, useState } from 'react';

import Side from './Side'

import BgColor from './BgColor'
import Randomizer from './Randomizer'
import Export from './Export';
import Adder from './Adder'
import {stateContext} from './ctx'
import Theme from './Theme'
import { icons } from './icons';
import Favs from './Favs';
import Love from './Love'
import FavsShow from './FavsShow';
import 'react-perfect-scrollbar/dist/css/styles.css';
import History from './History';


import Header from './Header';
import Mesh from './Mesh';
import MeshFooter from './MeshFooter';

const App = () => {

  const baseTheme = () => {
    let t = localStorage.getItem('CSSHEROMESHERTHEME')
    t = !t ? 'dark' : t;
    return t;
  }
  const [schema,setSchema] = useState(defaultSchema)
  const [bgMesh,setBgMesh] = useState('none')
  const [bgColor,setBgColor] = useState('hsla(0,100%,50%,1)')
  const [session,setSession] = useState(Date.now())
  const [hue,setHue] = useState(0)
  const [theme,setTheme] = useState(baseTheme())
  const [showFavs,setShowFavs] = useState(false)
  
  useEffect(()=>{
    setBgMesh(generateMeshCSS(schema,hue))
  },[schema,hue])

  useEffect(()=>{
    window.addEventListener('resize',()=>setSession(Date.now))
  },[])

  

  useEffect(()=>{
    document.documentElement.classList = theme
  },[theme])

  const ctx = {
    schema,setSchema,
    session,setSession,
    hue,setHue,
    bgColor,setBgColor,
    theme,setTheme,
    showFavs,setShowFavs,
    bgMesh,setBgMesh
  };
  
  const showFavsClass = showFavs ? '-left-96' : '-0'
  
  
  return <stateContext.Provider value={ctx}>
    <div className={'h-screen w-screen flex flex-col relative '+showFavsClass}>
      <Favs />
      <Header />
      <div className='flex flex-1'>
        <Mesh />
        <div className='flex flex-1 max-w-xs flex-col'>
        <BgColor />
       
          <div className='bg-mute-100 dark:bg-slate-800 mb-[2px] p-3 relative rounded-tr-xl rounded-tl-xl flex justify-end items-center gap-2 pr-5 mx-3'>
            <span className='mr-auto minititle'>Palette</span>
            <Love />
            <div className='h-8 w-[2px] mx-2 bg-slate-200 dark:bg-slate-700'></div>
            <History />
            <div className='h-8 w-[2px] mx-2 bg-slate-200 dark:bg-slate-700'></div>
            <Adder />
          </div>
       
          <div className='bg-mute-100 dark:bg-slate-800 relative flex-1 rounded-br-xl rounded-bl-xl mx-3'>
            <Side />
          </div>
          
        </div>
      </div>
      <div className='h-16 flex items-center'>
        <div className='flex flex-1'>
          <MeshFooter />
        </div>
        <div className='flex flex-1 max-w-xs p-3 gap-3 justify-end'>
          <Randomizer />
          <Export bgColor={bgColor} bgMesh={bgMesh} />
        </div>
      </div>
    </div>
  </stateContext.Provider>

}

export default App;
